import Travel from '../src/pages/index'
import './App.css';
import Navbar from '../src/components/Navbar'

function App() {
  return (
    <div className="App">
      <Navbar/>
     <Travel/>
    </div>
  );
}

export default App;
